import { render, staticRenderFns } from "./BusinessPrivacyPolicies.vue?vue&type=template&id=707bbcc2&scoped=true&"
import script from "./BusinessPrivacyPolicies.vue?vue&type=script&lang=js&"
export * from "./BusinessPrivacyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPrivacyPolicies.vue?vue&type=style&index=0&id=707bbcc2&scoped=true&lang=css&"
import style1 from "./BusinessPrivacyPolicies.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bbcc2",
  null
  
)

export default component.exports